export enum UploadAscWageReportStatus {
  NOT_STARTED = 'NOT_STARTED',
  UPLOADING = 'UPLOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}
